import components from './components';
import partials from './partials';
import dashboards from './dashboards';
import prod from './prod';
import solutions from './solutions';

export default [...components, ...partials, ...dashboards, ...prod, ...solutions];
